// Typelizer digest 3dc9663c93f8634089532296ac58add3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /passkeys/authentication_challenge */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/passkeys/authentication_challenge', {}, options),
    method: 'post',
  }),
}
